// src/features/actions/routes.ts
import { lazy } from 'react';
import { ClipboardCheck } from 'lucide-react';
import { RouteConfig } from '../../types/routing.types';

const ActionsDashboard = lazy(() => import('./ActionsDashboard'));
const ActionCreateForm = lazy(() => import('./components/ActionCreateForm'));
const ActionDetailPage = lazy(() => import('./components/ActionDetailPage'));
const TreatmentsList = lazy(() => import('./components/TreatmentsList'));
const ActionRequestsList = lazy(() => import('./components/ActionRequestsList'));
const ActionRequestCreateForm = lazy(() => import('./components/ActionRequestCreateForm'));
const TemplatesList = lazy(() => import('./components/TemplatesList'));

export const actionsRoutes: RouteConfig[] = [
  {
    path: '/actions',
    component: ActionsDashboard,
    label: 'Actions CAPA',
    icon: ClipboardCheck,
    showInNav: true,
    navPath: '/actions',
    breadcrumb: ['Accueil', 'Actions CAPA'],
  },
  {
    path: '/actions/new',
    component: ActionCreateForm,
    label: 'Nouvelle action',
    showInNav: false,
    breadcrumb: ['Accueil', 'Actions CAPA', 'Nouvelle action'],
  },
  {
    path: '/actions/:id',
    component: ActionDetailPage,
    label: 'Detail action',
    showInNav: false,
    breadcrumb: ['Accueil', 'Actions CAPA', 'Detail'],
  },
  {
    path: '/treatments',
    component: TreatmentsList,
    label: 'Traitements',
    showInNav: false,
    breadcrumb: ['Accueil', 'Actions CAPA', 'Traitements'],
  },
  {
    path: '/action-requests',
    component: ActionRequestsList,
    label: 'Demandes',
    showInNav: false,
    breadcrumb: ['Accueil', 'Actions CAPA', 'Demandes'],
  },
  {
    path: '/action-requests/new',
    component: ActionRequestCreateForm,
    label: 'Nouvelle demande',
    showInNav: false,
    breadcrumb: ['Accueil', 'Actions CAPA', 'Nouvelle demande'],
  },
  {
    path: '/templates',
    component: TemplatesList,
    label: 'Templates',
    showInNav: false,
    breadcrumb: ['Accueil', 'Actions CAPA', 'Templates'],
  },
];
